// Mock data for Savi Investing website

export const navigationItems = [
  {
    id: 'home',
    label: 'HOME',
    path: '/',
    hasDropdown: false
  },
  {
    id: 'savi',
    label: 'SAVI',
    path: '/savi',
    hasDropdown: false
  },
  {
    id: 'portfolio',
    label: 'INSIDE OUR PORTFOLIO',
    path: '/portfolio',
    hasDropdown: false
  },
  {
    id: 'framework',
    label: 'OUR INVESTING FRAMEWORK',
    path: '/framework',
    hasDropdown: false
  },
  {
    id: 'knowledge',
    label: 'KNOWLEDGE CENTRE',
    path: '/knowledge-centre',
    hasDropdown: false
  },
  {
    id: 'disclaimer',
    label: 'DISCLAIMER',
    path: '/disclaimer',
    hasDropdown: false
  },
  {
    id: 'reach',
    label: 'REACH US',
    path: '/reach-us',
    hasDropdown: false
  }
];

export const heroContent = {
  quote: "Everybody out there is chasing quick returns from the market. DON'T be everybody.",
  scrollText: "scroll down"
};

export const companyDescription = {
  title: "Savi Investing Pvt. Ltd.",
  description: "Savi Investing Pvt. Ltd. is an investing and trading firm that practices value-driven, disciplined investing. The company's flagship, proprietary portfolio is a concentrated mix of select Indian equities in different weightages. The portfolio is managed with the objective of deriving returns that consistently outperform the overall market over the long term.",
  ctaText: "Learn More",
  ctaLink: "/savi"
};

export const assets = {
  logo: "https://customer-assets.emergentagent.com/job_disciplined-returns/artifacts/mvula39g_SAVI-TM-sig.jpg",
  heroBackground: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f",
  aboutImage: "https://images.pexels.com/photos/6801680/pexels-photo-6801680.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  footerLogo: "https://customer-assets.emergentagent.com/job_disciplined-returns/artifacts/cagtxine_SAVI-TM-2B-1.jpg"
};
